import React, { useEffect, useState } from 'react';

import { IonContent } from '@ionic/react';
import { IonList, IonItem, IonHeader, IonTitle, IonToolbar, IonButtons, IonBackButton } from '@ionic/react';
import OptionService from '../services/option';
import { sanitizeShiftsHtml, shiftsTitle } from '../utils/shifts';

import '../theme/shifts.css';

const ShiftsPage = (props) => {
  const [options, setOptions] = useState(null);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await OptionService.allClean();
        const optionsData = response.data.data;
        setOptions(optionsData);
      } catch (error) {
        console.error('Errore durante il caricamento delle opzioni:', error);
      }
    };
    fetchOptions();
  }, []);

  return (
    <>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/" />
          </IonButtons>
          <IonTitle>Turni</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent class="ion-padding-top" fullscreen>
        {options?.turni_content ? (
          <>
            <div className="shifts-header">
              <h1 className="shifts-title">{shiftsTitle(options?.shop_name)}</h1>
            </div>

            <div className="shifts-body">
              <div
                className="shifts-text"
                dangerouslySetInnerHTML={{ __html: sanitizeShiftsHtml(options.turni_content.html) }}
              />

              {options.turni_content.image_url && (
                <div className="shifts-figure">
                  <img className="shifts-image" src={options.turni_content.image_url} alt={shiftsTitle(options?.shop_name)} />
                </div>
              )}
            </div>
          </>
        ) : options?.turni ? (
          <iframe
            src={`${options?.turni}`}
            style={{ width: '100%', height: '100vh', border: 'none' }}
            title="PDF Viewer"
          />
        ) : (
          <IonList>
            <IonItem>Al momento non ci sono turni disponibili.</IonItem>
          </IonList>
        )}
      </IonContent>
    </>
  );
};

export default ShiftsPage;
